import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";

function NumberField({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState("");

  const [element, setElement] = useState({
    type: "number",
    properties: {
      label: "Number Element",
      placeholder: "Enter Number Element here...",
      required: true,
    },
  });

  const [readOnly, setReadOnly] = useState(false);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    setElement((prev) => ({ ...prev, ...data }));
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }

    if (data?.properties?.label === "Phone Number") {
      if (data?.properties?.value && data?.properties?.value?.length !== 0) {
        setReadOnly(true);
      } else if (data?.properties?.label === "Email") {
        setReadOnly(false);
      } else {
        setReadOnly(false);
      }
    } else if (data?.properties?.label === "Employee Referal ID") {
      if (data?.properties?.value && data?.properties?.value?.length !== 0) {
        setReadOnly(true);
      }
    }
    //check prefilled field -Lovejot(07-DEC-2022)
    // if (
    //   data?.disableField === true &&
    //   data?.properties?.value &&
    //   data?.properties?.value?.length !== 0 &&
    //   localStorage.getItem("user.role") !== "admin"
    // ) {
    //   setReadOnly(true);
    // } else {
    //   setReadOnly(false);
    // }
  }, [data, isChild]);

  useEffect(() => {
    const labelsToCheck = ["PIN Code", "Total experience in month"];
    const currentLabel = data?.properties?.label;

    if (labelsToCheck.includes(currentLabel)) {
      const currentValue = data?.properties?.value?.trim()?.toLowerCase() || "";
      const comparisonValue = data?.comparison || "";
      if (comparisonValue !== currentValue) {
        setElement((prev) => ({ ...prev, isEdited: true }));
      }else{
        setElement((prev) => ({ ...prev, isEdited: false }));
      }
    }
  }, [data?.properties?.value]);

  const handleChange = (val) => {
    const editableLabels = ["PIN Code", "Total experience in month"];

    const currentLabel = element?.properties?.label;

    if (editableLabels.includes(currentLabel)) {
      const inputValue = val?.trim()?.toLowerCase() || "";
      const comparisonValue = element?.comparison || "";
      console.log({ comparisonValue, inputValue });
      setElement((prev) => ({
        ...prev,
        isEdited: comparisonValue !== inputValue,
      }));
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group col-md-12 form-builder-element mb-3">
      <label htmlFor="">
        {element.properties.label}
        <If test={element.properties.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>
      <input
        onBlur={onBlurHandler}
        onChange={(e) => {
          handleChange(e.target.value);
          if (isInputFieldTouched) {
            isInputFieldTouched();
          }
        }}
        disabled={
          readOnly ||
          approve ||
          !element.editable ||
          (defValue && hasChiledReadOnly) ||
          ocrDisabled
        }
        className={`form-control form-view ${
          foundError ? "border border-danger" : ""
        }`}
        type="number"
        // defaultValue={defaultValue}
        defaultValue={defValue && isChild ? defValue : element.properties.value}
        label={element.properties.label}
        placeholder={element.properties.placeholder}
        data={JSON.stringify(element)}
      />
      {foundError && <p className="text-danger">{foundError?.value}</p>}
    </div>
  );
}

export default NumberField;
